export default "__VITE_ASSET__BORvBrzJ__"